import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Map, Globe2 } from 'lucide-react';
export function GlobalArchitecture() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-surface-muted rounded-3xl my-12" data-id="element-648" data-mp="13c6lzw59olux">
      <div className="text-center mb-16" data-id="element-649" data-mp="yghkvodlmwwi">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-650" data-mp="tg3l0tm5it9k">
          Global Architecture
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-651" data-mp="1r299s025f5nq">
          A framework for capability, resilience, and governance
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-16" data-id="element-652" data-mp="1hc7pljcx27e3">
        {/* Municipal */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col" data-id="element-653" data-mp="1cdd7kjmrwmv1">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-654" data-mp="wh1wh4yure1j">
            <MapPin size={20} className="text-navy-light" data-id="element-655" data-mp="wj5w3appxqw0" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-656" data-mp="iolmfk7jafr4">
              Municipal
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-657" data-mp="nmwwnw1qqs9v">
            Local capability gaps, youth opportunity pipelines, community
            resilience, and civic engagement metrics.
          </p>
        </motion.div>

        {/* Regional */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="flex flex-col" data-id="element-658" data-mp="3vwq4t7g61n3d">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-659" data-mp="1z1kaiohjhevl">
            <Map size={20} className="text-teal" data-id="element-660" data-mp="1wn5bwq3fi9kj" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-661" data-mp="1snepeykxqflt">
              Regional / Provincial
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-662" data-mp="1notp6z5onvxd">
            Education reform, workforce planning, leadership development, and
            structural resilience strategy.
          </p>
        </motion.div>

        {/* National */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-col" data-id="element-663" data-mp="2beebns11pbbe">
          <div className="flex items-center gap-3 mb-4 border-b border-line pb-4" data-id="element-664" data-mp="2z5tcthh35ml2">
            <Globe2 size={20} className="text-navy" data-id="element-665" data-mp="2ubp9r9axxyp9" />
            <h3 className="text-xl font-heading font-bold text-ink-dark" data-id="element-666" data-mp="31oojm86rf3jh">
              National
            </h3>
          </div>
          <p className="text-ink-muted leading-relaxed" data-id="element-667" data-mp="36o15aplwa4kh">
            Civil-service modernization, ministry-level planning, executive
            readiness, and national capability mapping.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="text-center" data-id="element-668" data-mp="3gj2shfwm0wkf">
        <p className="text-lg font-medium text-navy bg-white inline-block px-8 py-4 rounded-lg shadow-sm border border-line" data-id="element-669" data-mp="3uf6j6z89yms5">
          At scale, NCJI becomes a strategic intelligence layer for human
          development and institutional performance.
        </p>
      </motion.div>
    </section>;
}